/**
 * Utility functions for trackBy in *ngFor loops to optimize rendering performance.
 * These functions return a unique identifier for each item, or fallback to index if missing.
 */

export function trackById<T extends {id?: string}>(index: number, item: T): string | number {
    return item?.id ?? index;
}

export function trackByValue<T extends {value?: string}>(index: number, item: T): string | number {
    return item?.value ?? index;
}

